import IconButton from '../../../components/atoms/button/IconButton';

interface ContentTypeButtonProps {
  label: string;
  selected: boolean;
  icon: string;
  disabled: boolean;
  onSelect?: () => void;
  onDelete?: () => void;
}

export default function ContentTypeButton({
  label,
  selected,
  icon,
  disabled,
  onSelect,
  onDelete,
}: ContentTypeButtonProps) {
  return (
    <div>
      <IconButton
        className="w-full mb-2"
        label={label}
        visualType={selected ? 'secondary-blue-text' : 'primary'}
        orientation="column"
        iconSize="lg"
        icon={icon}
        disabled={disabled}
        onClick={onSelect}
      />
      {selected && (
        <IconButton className="w-full" icon="delete-outline" label="Delete" visualType="secondary" onClick={onDelete} />
      )}
    </div>
  );
}
